import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
//引入全局路由守卫
import "@/router/permit"
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/assets/fonts/iconfont.css';
import '@/assets/css/global.css'; 
import '@/styles/main.scss';
import { startSessionExpiryWatcher } from '@/utils/auth'

const app=createApp(App);
app.use(ElementPlus, { locale: zhCn })
app.use(router);
app.use(store); 
// 注册所有图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.mount('#app');

startSessionExpiryWatcher()
